module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "50px"
    },
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUsbOnly),
      expression: "!isUsbOnly"
    }],
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 wow fadeIn",
    attrs: {
      "data-wow-delay": "0.9s"
    }
  }, [_c('div', {
    staticClass: "box box-widget widget-user-2"
  }, [_c('downloadBtn', {
    staticStyle: {
      "width": "300px",
      "text-align": "center"
    },
    attrs: {
      "title": _vm.btnLAN.title,
      "img": _vm.btnLAN.img,
      "info": _vm.btnLAN.info,
      "icon": _vm.btnLAN.icon,
      "btnText": _vm.btnLAN.btnText
    },
    on: {
      "click": function($event) {
        return _vm.downloadClient()
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNetworkOnly),
      expression: "!isNetworkOnly"
    }],
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 wow fadeIn",
    attrs: {
      "data-wow-delay": "0.9s"
    }
  }, [_c('downloadBtn', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "title": _vm.btnUSB.title,
      "img": _vm.btnUSB.img,
      "info": _vm.btnUSB.info,
      "icon": _vm.btnUSB.icon,
      "btnText": _vm.btnUSB.btnText
    },
    on: {
      "click": function($event) {
        return _vm.downloadClientUSB()
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 wow fadeInLeft",
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('h4', [_c('strong', [_vm._v("Network Printers Client Installer")])]), _vm._v(" "), _c('p', [_vm._v("Download \"Network Client Installer\" for monitoring Network printers")]), _vm._v(" "), _c('p', [_vm._v("Collect NETWORK printer counters automatically & schedule reports")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 wow fadeInLeft",
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('h4', [_c('strong', [_vm._v("USB Printers Client Installer")])]), _vm._v(" "), _c('p', [_vm._v("Download \"USB Client Installer\" for monitoring USB printers")]), _vm._v(" "), _c('p', [_vm._v("Collect USB printer counters automatically & schedule reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90357086!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/download.vue
// module id = 736
// module chunks = 0